import React from 'react'
import { useProduct } from '../../context/product_context'
import { ProductDetails } from '../ProductDetails'

export const Step4 = () => {
    const { productInfo } = useProduct()
    return <></>
}
